module.exports = __webpack_public_path__ + "static/img/RE6.a707c9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/RE6.jpg
// module id = e2i9
// module chunks = 0